import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'primereact/button';
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetStocks, UpdateStock } from 'services/stock/stock.service';
import { TableStock } from 'components/Table/TableStock';
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import CreateModal from 'components/Modal/CreateModal';
import { coreAxios } from "utilities/axios";
import AuthContext from  "../../context/AuthContext";
import { StockValidationSchema } from 'utilities/ValidationSchema/Stock/StockValidationSchema';
const BASE_URL = process.env.REACT_APP_MAIN_URL

const Stock = () => {
    const { stockList, stockListLoading } = useSelector((state) => state.stockList);
    const { stockUpdate, stockUpdateLoading } = useSelector((state) => state.stockUpdate);

    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();
    const { user } = useContext(AuthContext);


    const updateInitialValue = {
        ...updateData,
    };

    const formik = useFormik({
        initialValues: updateInitialValue, // * if state is update then updateData state value will show up
        validationSchema: StockValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            handelSubmit(values);
        },
        enableReinitialize: true,
    });

    const editStock = (stock) => {
        setShowForm(true); // * set the form to true
        setUpdateData(stock);
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateStock(data)).then(() => {
                hideModal();
            });
            return
        }
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetStocks());
    }, [stockUpdate]);


    // columns of the table with header name
    const tableColumns = [
        { field: "shop", header: "Shop", sortableBody: NameColumn },
        { field: "name", header: "Name", sortableBody: NameColumn },
        { field: "code", header: "Product code", sortableBody: TextColumn },
        { field: "uom", header: "Uom", sortableBody: TextColumn },
        { field: "sold_quantity", header: "Total Sold quantity", sortableBody: TextColumn },
        { field: "available_stock_quantity", header: "Available Stock Quantity", sortableBody: TextColumn },
    ];


        // * input data array of object for the form / modal
        const inputData = [
            {
                id: "stock_quantity",
                name: "stock_quantity",
                value: "stock_quantity",
                type: "number",
                labelFor: "Stock Quantity",
                label: "Stock Quantity",
                required: true,
                messagePosition: 'toast',
                className: "col-12",
            },
            {
                id: "sell_quantity",
                name: "sell_quantity",
                value: "sell_quantity",
                type: "number",
                labelFor: "Sell Quantity",
                label: "Sell Quantity",
                required: true,
                messagePosition: 'toast',
                className: "col-12",
            },
            {
                id: "rate",
                name: "rate",
                value: "rate",
                type: "text",
                labelFor: "Rate",
                label: "Rate",
                required: true,
                messagePosition: 'toast',
                className: "col-12",
            },
        ];
    
    const downloadBarcode = async (data) => {

        const url = `${BASE_URL}/api/single/stock/barcode/download/${data?.id}/`;
        try {
            const response = await coreAxios.get(url, {
                responseType: 'blob',
            });
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `${data?.name}-barcode.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
            console.log(error)
        }
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        user.user_type === 'ADMIN' ? <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editStock(rowData)} /> : ''
                    }
                    
                    <Button 
                        icon="pi pi-download" 
                        className="p-button-rounded p-button-secondary" 
                        onClick={(e) => {
                            downloadBarcode(rowData)
                        }}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <TableStock
                //data
                tableHeaderName="Stock Details"
                tableColumns={tableColumns}
                data={stockList}
                loading={stockListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable={false}
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <CreateModal 
                dialogVisible={showForm} 
                position="top"
                column={3} 
                onHide={hideModal} 
                inputData={inputData} 
                formik={formik} 
                dialogHeader={`${!updateData ? "Create" : "Update "} Stock`} 
                modalWidth="400px" 
                reset={resetForm} 
                btnLoading={stockUpdateLoading} 
                update={updateData} 
                col1={4}
                col2={updateData ? 3 : 4}
                col3={6}
            />
        </>
    );
};

export default Stock;
